import { render } from "./attHM.vue?vue&type=template&id=2b48f665&scoped=true"
import script from "./attHM.vue?vue&type=script&lang=js"
export * from "./attHM.vue?vue&type=script&lang=js"

import "./attHM.vue?vue&type=style&index=0&id=2b48f665&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b48f665"]])

export default __exports__